import { render } from "./DropIcon.vue?vue&type=template&id=4eaa28ea"
const script = {}
script.render = render

export default script